import { render } from "./TestCaseValidationResultsCompareModal.vue?vue&type=template&id=052d8c4c&scoped=true"
import script from "./TestCaseValidationResultsCompareModal.vue?vue&type=script&lang=js"
export * from "./TestCaseValidationResultsCompareModal.vue?vue&type=script&lang=js"

import "./TestCaseValidationResultsCompareModal.vue?vue&type=style&index=0&id=052d8c4c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052d8c4c"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QDialog});
